
import { Vue, Component, Prop } from "vue-property-decorator";
import MANAGEMENT_CLIENTS from "@/apollo/projects/GetProjectCounts.gql";
import ProjectModal from "@/components/companyProjects/ProjectModalNew.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesV2.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubbleV2.vue";
import { Company, User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RouteTabs from "@/entities/RouteTabs";
import RouteNames from "@/entities/RouteNames";

@Component({
  components: {
    TabsWithRoutes,
    TabNotificationBubble,
    ProjectModal,
  },
  apollo: {
    projects: {
      query: MANAGEMENT_CLIENTS,
      variables() {
        return this.visitsFilter;
          },
      update(data) {
        this.activeTotal = data.activeCount.aggregate.count;
        this.draftTotal = data.draftedCount.aggregate.count;
        this.closedTotal = data.completedCount.aggregate.count;
        return data.project;
      },
    },
  },
})
export default class AllClients extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  routes = RouteNames;
  containerClasses: string = "h-full";
  activeTotal: number = 0;
  draftTotal: number = 0;
  closedTotal: number = 0;

  dialog: boolean = false;

  get isResourcesPage(): boolean {
    return this.$route.path.includes("/company_database/");
  }
  get isTalentMapping(): boolean {
    return this.$route.path.includes("/talent-mapping");
  }
  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }
  get currentUserManagerId(): string {
    return this.currentUser.manager!.id;
  }

  get totalClient(): number{
    return this.activeTotal + this.draftTotal + this.closedTotal;
  }

  get isManager(): boolean {
    return this.currentUser.role === Roles.MANAGER;
  }

  get visitsFilter() {
    if (this.isManager) {
      return {
        companyId: this.company.id,
        projectActivitiesWhere:{
       project: {
        manager: { id: { _eq: this.currentUserManagerId } }
      },
        }
      };
    }
    return { 
       companyId: this.company.id,
    //    projectActivitiesWhere:{
    //   // project: { companyId: this.company.id}}
    // };
  }
  }

  get routeTabs(): RouteTabs {
    return {
      [RouteNames.ALL_ACTIVE_CLIENTS]: `Active client profile`,
      [RouteNames.ALL_COMPLETED_CLIENTS]: `Closed Clients profile`,
      [RouteNames.ALL_DRAFT_CLIENTS]: `Draft Clients profile`,
    };
  }

  toggle(): void {
    this.dialog = true;
  }
}
